

























































































import {
  Vue,
  Component,
} from "vue-property-decorator";
import CardView from './CardView.vue';
import ButtonGroup from './ButtonGroup.vue';
import CardConent from './CardConent.vue'
import PieView from './PieView.vue';
import LineView from './lineView.vue'
import ListView from './ListView.vue';
import HomePageService from './HomePageService';
import NoticeView from '../notice/NoticeView.vue'
import NoticeViews from './NoticeView.vue'
@Component({
  components: {CardView,ButtonGroup,CardConent,PieView,LineView,ListView,NoticeView,NoticeViews}
})
export default class HomePage extends Vue {
  public GroupName = {
    FORM : 'FORM',
    WARN : 'WARN',
    CATEGORY : 'CATEGORY',
    CHANNEL : 'CHANNEL'
  }
  public buttonGroupType = {
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month'
  }
    public a : String = '/assets/png/报警.png'
    public b : String = '/assets/png/备件工单补库量.png'
    public c : String = '/assets/png/待上门工单量.png'
    public d : String = '/assets/png/工程师领用量.png'
    public e : String = '/assets/png/回执工单量.png'
    public f : String = '/assets/png/收益.png'
    public g : String = '/assets/png/投诉量.png'
    public h : String = '/assets/png/遗留量.png'
    public buttonParam:Array<any> = [{key: "day",value:"日"},{key: "week",value:"周",isActive: true},{key: "month",value:"月"}]
    public buttonParam1:Array<any> = [{key: "day",value:"日"},{key: "week",value:"周",isActive: true},{key: "month",value:"月"}]
    public buttonParam2:Array<any> =[{key: "day",value:"日"},{key: "week",value:"周",isActive: true},{key: "month",value:"月"}]
    public buttonParam3:Array<any> = [{key: "day",value:"日"},{key: "week",value:"周",isActive: true},{key: "month",value:"月"}]

    public todoList:Array<any> = [];
    public messageList:Array<any> = [];
    public noticeList:Array<any> = [];
    public noticeVisible: boolean = false;
    public noticeId: string = '';

    public visitForm: number = 0;
    public receiptForm: number = 0;
    public leaveOver: number = 0;
    public subscribeOver: number = 0;
    public door: number = 0;
    public complain: number = 0;

    public monthComplain : any = [];
    public monthForm : any= [];

    public channelAdd: any = [];
    public typeAdd: any = [];

    public buttonClick(value : any) {
        if(value.groupName == this.GroupName.FORM) {
            this.getVisitForm(value.key);
            this.getReceiptForm(value.key);
            this.getLeaveOver(value.key);
        } else if (value.groupName == this.GroupName.WARN) {
            this.getSubscribeOver(value.key);
            this.getDoor(value.key);
            this.getComplain(value.key);
        } else if (value.groupName == this.GroupName.CATEGORY) {
           this.getTypeAdd(value.key);
        }  else if (value.groupName == this.GroupName.CHANNEL) {
            this.getChannelAdd(value.key);
        }
    }

    created() {
      this.getVisitForm(this.buttonGroupType.WEEK);
      this.getReceiptForm(this.buttonGroupType.WEEK);
      this.getLeaveOver(this.buttonGroupType.WEEK);
      this.getSubscribeOver(this.buttonGroupType.WEEK);
      this.getDoor(this.buttonGroupType.WEEK);
      this.getComplain(this.buttonGroupType.WEEK);

      this.getNotice({page:0,size: 5,n_client_type_eq:'pc'});
      this.getToList({ pageBean: {
              page: 1,
              pageSize: 5
          }});
      this.getMessageList({size: 5,page: 0,sort: 'create_date,desc'})
      //@ts-ignore
      this.$bus.$on('isread',(e:any)=> {
        if (e) {
           this.getNotice({page:0,size: 5,n_client_type_eq:'pc'});
        }
      })
      this.get12MonthForm();
      this.get12MonthComplain()
      this.getChannelAdd(this.buttonGroupType.WEEK);
      this.getTypeAdd(this.buttonGroupType.WEEK);

    }


    public getLevel(level : string) {
      if (level == '高') return 'danger';
      if (level == '中') return 'warning';
      if (level == '低') return 'success';
    }

    /**
     *  公告弹窗关闭回调
     */


    public noticeViewClose() {
       this.noticeVisible = false;
    }

    /**
     * 数据请求赋值
     */
         /**
      * 待上门工单量
      */
     public getVisitForm(type: string){
       HomePageService.getVisitForm(type).then(res => {
         if(res.data && res.data.length > 0) {
           this.visitForm = res.data[0].number || 0;
         }
       })
     }
     /**
      * 已回执工单量
      */
     public getReceiptForm(type: string) {
          HomePageService.getReceiptForm(type).then(res => {
         if(res.data && res.data.length > 0) {
           this.receiptForm = res.data[0].number || 0;
         }
       })
     }
    /**
      * 超期遗留量
      */
     public getLeaveOver(type: string) {
          HomePageService.getLeaveOver(type).then(res => {
         if(res.data && res.data.length > 0) {
           this.leaveOver = res.data[0].number || 0;
         }
       })
    }
    /**
      * 预约超期量
      */
     public getSubscribeOver(type: string) {
          HomePageService.getSubscribeOver(type).then(res => {
         if(res.data && res.data.length > 0) {
           this.subscribeOver = res.data[0].number || 0;
         }
       })
    }
    /**
      * 件到待上门量
      */
     public getDoor(type: string) {
         HomePageService.getDoor(type).then(res => {
         if(res.data && res.data.length > 0) {
           this.door = res.data[0].number || 0;
         }
       })
    }
    /**
      * 投诉量
      */
     public getComplain(type: string) {
         HomePageService.getComplain(type).then(res => {
         if(res.data && res.data.length > 0) {
           this.complain = res.data[0].number || 0;
         }
       })
    }

    /**
     * 品类新增工单量概览
     */
     public getTypeAdd(type: string) {
         HomePageService.getTypeAdd(type).then(res => {
         if(res.data && res.data.length > 0) {
           this.typeAdd = res.data;
         } else {
           this.typeAdd = [];
         }
       })
    }
    /**
     * 渠道新增工单量概览
     */
     public getChannelAdd(type: string) {
         HomePageService.getChannelAdd(type).then(res => {
         if(res.data && res.data.length > 0) {
           this.channelAdd = res.data;
         } else {
           this.channelAdd = [];
         }
       })
    }

    /**
     * 公告通知
     */
    public getNotice(param : Object) {
      HomePageService.getNotice(param).then(res => {
        if (res.data && res.data.length > 0) {
          this.noticeList = res.data;
        } else {
          this.noticeList = [];
        }
      })
    }

        /**
     * 公告点击事件
     */
    public noticeRightClick(data : any) {
      this.noticeVisible = true;
      this.noticeId = data.mpnoticeid;
      setTimeout(()=>{
        this.getNotice({page:0,size: 5,n_client_type_eq:'pc'});
      },2000)
    }

    /**
     * 消息预警点击事件
     */

    public messageRightClick(data : any) {
      this.$confirm(data.msginfo, '消息内容', {
            confirmButtonText: '确定',
            type: "success",
            showCancelButton:false
        })
      try {
        this.$http.post(`/runtimeapi/readWebMsg/${data.msgsendid}`,{})
      } catch (error) {

      } finally{
        setTimeout(()=>{
          this.getMessageList({size: 5,page: 0,sort: 'create_date,desc'})
        },1000)
      }
    }

    /**
     *  公告more
     */
    public noticeMore(){
      this.$router.push('/appindexview/null/notice-table')
    }
    /**
     * 消息预警more
     */

    public messageMore(){
      this.$router.push('/appindexview/null/message-table')
    }

        /**
     * 待审批列表
     */

    public todoMore(){
      this.$router.push('/appindexview/null/todoTask')
    }


    /**
     * 待审批列表
     */
    public getToList(param: object) {
      HomePageService.getToList(param).then(res => {
        if (res.data && res.data.value.rows.length > 0) {
          this.todoList = res.data.value.rows;
        } else {
          this.todoList = [];
        }
      })
    }
    //跳转css的工程项目详情页
    public jumpBasic(data:any){
      let routePath=`/cssbd/null/bdprojects/${data.id}/editview?bdprojectid=${data.id}`
      this.$router.push(routePath)
      window.postMessage({
          type: 'singleRoute',
          data: {
              current: JSON.stringify(Object.assign({}, {
                  fullPath: routePath,
                  path: routePath.replace(/\?.*/g, '')
              }))
          }
      }, window.location.origin)
    }
    /**
     * 待审批处理
     */
    public handleTodoTask(data : any) {
      if(data.type=='css'){
        this.jumpBasic(data)//跳转css的工程项目详情页
        return
      }
      HomePageService.getOASignUrl(data.taskUrl).then((res) => {
        if (res && res.data) {
          let url = res.data.value;
          let token: string = window.sessionStorage.getItem("token") as any;
          HomePageService.getSSOCode(token).then((res) => {
            if (res && res.data) {
              url = url.replace("[ssoCode]", res.data);
              window.open(url);
            }
          });
        }
      }).catch((err: any) => {
        alert("请求OA数据错误:"+err?.data?.error)
      });
    }

    /**
     * 消息预警
     */
    public getMessageList(param: object) {
      HomePageService.getMessage(param).then(res => {
        if (res.data && res.data.length > 0) {
          this.messageList = res.data;
        } else {
          this.messageList = [];
        }
      })
    }

    /**
     * 12 个月趋势
     */
    public get12MonthComplain() {
      HomePageService.get12MonthComplain().then(res => {
        if (res.data && res.data.length > 0) {
          this.monthComplain = res.data;
        } else {
          this.monthComplain = [];
        }
      })
    }
    public get12MonthForm() {
      HomePageService.get12MonthForm().then(res => {
        if (res.data && res.data.length > 0) {
          this.monthForm = res.data;
        } else {
          this.monthForm = [];
        }
      })
    }


    public formatDate(param : any){
      return HomePageService.formatDate(param);
    }
}
